module.exports = __webpack_public_path__ + "img/yy-s2.6b1112ee.svg";